<template>
  <span class="group flex items-center justify-start">
    <span
      :class="classObject"
      class="p-1 flex items-center justify-center bg-ocean-100 text-ocean-700 rounded-full text-lg"
    >
      {{ getInitials }}
    </span>
    <span
      v-if="showName"
      class="text-neutral-600 group-hover:text-neutral-900"
    >
      {{ name }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'VetsterClientImage',

  props: {
    name: {
      default: undefined,
      type: String,
    },
    size: {
      default: 'sm',
      type: String,
    },
    noMargin: {
      default: false,
      type: Boolean,
    },
    showName: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    getInitials() {
      return this.name.charAt(0).toUpperCase();
    },
    classObject() {
      return {
        'size-8': this.size === 'xs',
        'size-10': this.size === 'sm',
        'size-16': this.size === 'md',
        'size-20': this.size === 'lg',
        'mr-3': !this.noMargin,
      };
    },
  },
};
</script>
